import React, { lazy } from 'react';
import IconMetricKit from '@/assets/images/menu/icon-metrickit.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { ExperienceTag } from '@/presentation/components/experience-tag';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const metricKitRoutes = (): IRouteConfig[] => [
  {
    path: '/kit',
    name: 'MetricKit',
    platforms: [
      CapitalPlatform.IOS,
      CapitalPlatform.VisionOS,
    ],
    sort: 87,
    icon: <MenuIcon icon={IconMetricKit} fontSize={16} />,
    authName: AuthNodes.MetricKit,
    disabledByFree: true,
    routes: [
      {
        path: '/kit/log',
        name: '日志查询',
        component: lazy(() => import('@/presentation/pages/metric-kit/log')),
      },
      {
        path: '/kit/crash-diagnostics',
        name: 'crashDiagnostics',
        suffix: <ExperienceTag />,
        component: lazy(() => import('@/presentation/pages/metric-kit/crash-diagnostics')),
      },
      {
        path: '/kit/crash-diagnose-detail',
        name: '问题诊断详情',
        component: lazy(() => import('@/presentation/pages/metric-kit/crash-diagnose-detail')),
        hideInMenu: true,
        whitelisted: true,
      },
    ],
  },
];

export default metricKitRoutes;
